import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const sanitiseUrl = path => {
  const url = new URL(path, "https://www.asos.com/");
  const { pathname, search } = url;

  return {
    pathname,
    search
  };
};

const SinglePageAppLink = ({ href, children, setIsNewPage, ...props }) => {
  const { pathname, search } = sanitiseUrl(href);

  return (
    <Link
      onClick={setIsNewPage}
      to={{
        pathname,
        search
      }}
      {...props}
    >
      {children}
    </Link>
  );
};

SinglePageAppLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  setIsNewPage: PropTypes.func.isRequired
};

export default SinglePageAppLink;
